export const DefinedPermissions = {
  // =================
  contentCreateAndEditPermission: 'Create & Edit Content tabs',
  viewUnpublishedContentsPermission: 'Unpublished Contents tabs View',
  editUnpublishedContentsPermission: 'Unpublished Contents -Edit',
  approveUnpublishedContentsPermission: 'Unpublished Contents - Approval',
  deleteUnpublishedContents: 'Unpublished Contents - Delete',
  viewPublishedContentsPermission: 'Published Contents tabs View',
  editPublishedContentsPermission: 'Published Contents - Edit',
  archivePublishedContentsPermission: 'Published Contents - Archive',
  deletePublishedContents: 'Published Contents - Delete',
  publishedContentsNewsOnTopPermission: 'Published Contents - NewsOnTop',
  modifyPointsPublishedContentsPermission: 'Published Contents - Add /Modify points',
  viewRankedContentsPermission: 'Ranked Contents View',
  rankedContentsActionsIconPermission: 'Ranked Contents - Actions Icon',
  viewPushNotificationCountersListPermission: 'Reports:Push Notification Counters',
  viewVideoPlayCountersListPermission: 'Reports:VideoPlayCounters',
  previewBoxOfficePermission: 'Preview Boxoffice',
  createPeoplePermission: 'People:People Creation',
  listPeoplePermission: 'People:List People',
  contentAnalyticsPermission: 'Content Analytics',
  syncArticlesPermission: 'Articles:Sync now',
  articlesListPermission: 'Articles:List',
  dragAndDropArticlesPermission: 'Articles:Drag and Drop',
  moveArticleFromBacklogPermission: 'Articles:Move From Backlog To Completed',
  updateContentStickyPermission: 'Update Content : Sticky',
  addContentToListPermission: 'Add Content To List',
  deletePeoplePermission: 'Delete People',
  dragAndDropContentsToRank: 'Ranked Contents:Drag And Drop',
  addOrRemoveFromBoxOfficePermission: 'Add Or Remove From Box Office',
  repostContentPermission: 'Repost Content',
  listAssociationsPermission: 'Associations:List',
  listFeaturedMatchesPermission: 'Featured Matches:List',
  listAssociationFeaturedMatchesPermission: 'AssociationFeaturedTournaments:List',
  duplicateContentPermission: 'Published Contents - Duplicate',
  viewCreatorOrPlannerPointsListPermission: 'creatorOrPlannerPoints:Report',
  sendContentPushNotificationPermission: 'sendContentPushNotification',
  // duplicateContentPermission: 'Published Contents - Duplicate',
  displayActiveUsersCount: 'Display Active Users Count',
  DisplayApproveMovieOption: 'Approve in Edit Movie',
  DisplayApprovePersonOption: 'Approve in Edit Person',
  AllMoviesEdit: 'List Movies-Edit',
  AllMoviesDelete: 'List Movies-Delete',
  AllMoviesBulkAction: 'List Movies-BulkActions (delete/publish/draft)',
  AllPersonsBulkAction: 'List Persons-BulkActions(delete/publish/draft)',
  EditPeronPermission: 'Edit Person',
  CreateMoviePermission: 'Create Movie',
  EditMoviePermission: 'Edit Movie',
  DeletePersonPermission: 'List Persons-Delete',
  DynamicListCreate: 'DynamicList -Create',
  CreatePerson: 'Create Person',
  allPersonsView: 'List Persons-View',
  allMoviesView: 'List Movies-View',
  MergePersonsPermission: 'Merge Persons',
  movielistView: 'Movie List-View',
  DynamiclistView: 'All DynamicList -View',
  CollectionView: 'All Collections -View',
  ImportMoviesPersons: 'Import Movie and Persons',
  ScrapePermission: 'Scrape',
  CreateJob: 'Create Job',
  activeJobs: 'Active Job - View',
  draftJobs: 'Draft Job - View',
DynamicListEdit: 'DynamicList-Edit',
DynamicListDelete: 'DynamicList -Delete',
DynamicListApprove: 'DynamicList -Approve',
DynamicListBulkActions: 'DynamicList-BulkActions (delete/publish/draft)',
CollectionCreate: 'Collection -Create',
CollectionEdit: 'Collection -Edit',
CollectionDelete: 'Collection -Delete',
CollectionApprove: 'Collection -Approve',
CollectionBulkActions: 'Collection-BulkActions (delete/publish/draft)',
MovieListCreate: 'Movie List-Create',
MovieListApprove: 'Movie List-Approve',
MovieListBulkActions: 'Movie List Bulk Actions (delete/publish/draft)',
MovieListDelete: 'Movie List-Delete',
MovieListEdit: 'Movie List-Edit',
MovieAndOTTNewsEdit: 'Edit Movie And OTT News Updates in Movie',
MovieAndOTTNewsDelete: 'Remove Movie And OTT News Updates in Movie',
MovieAndOTTNewsApprove: 'Approve Movie And OTT News Updates in Movie',
}
